/** @format */
import { ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import {
    CourseUnit,
    CustomCourseUnitAttainment,
    CustomModuleAttainment,
    CustomStudyDraft,
    DegreeProgramme,
    DegreeProgrammeAttainment,
    Education,
    GroupingModule,
    Module,
    ModuleAttainment,
    OtmId,
    StudyModule,
} from 'common-typescript/types';
import {
    isCustomCourseUnitAttainment,
    isCustomModuleAttainment,
    isModuleOrDegreeProgrammeAttainment,
} from '../../attainment/AttainmentUtil';
import { getAttainmentFromPlanData } from '../../service/attainment-in-plan-data';
import { EducationStateObject, ModuleStateObject } from '../../service/plan-state.service';
import { PlanStructureContext } from '../plan-structure-context';

@Component({
    selector: 'sis-plan-structure-module-content',
    templateUrl: './plan-structure-module-content.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureModuleContentComponent {
    @Input({ required: true }) moduleOrEducationStateObject: EducationStateObject | ModuleStateObject;
    @Input({ required: true }) moduleOrEducation: Education | Module;
    @Input() isImplicit: boolean;
    @Input({ required: true }) headingLevel: number;

    protected readonly planStructureContext = inject(PlanStructureContext);

    getCustomCourseUnitAttainment(id: OtmId): CustomCourseUnitAttainment | undefined {
        return getAttainmentFromPlanData(this.planStructureContext.planData(), id, isCustomCourseUnitAttainment);
    }

    getCustomModuleAttainment(id: OtmId): CustomModuleAttainment | undefined {
        return getAttainmentFromPlanData(this.planStructureContext.planData(), id, isCustomModuleAttainment);
    }

    getModuleAttainment(id: OtmId): ModuleAttainment | DegreeProgrammeAttainment | undefined {
        return getAttainmentFromPlanData(this.planStructureContext.planData(), id, isModuleOrDegreeProgrammeAttainment);
    }

    getModule(id: OtmId): StudyModule | DegreeProgramme | GroupingModule {
        return this.planStructureContext.planData().modulesById[id] as StudyModule | DegreeProgramme | GroupingModule;
    }

    getCourseUnit(id: OtmId): CourseUnit {
        return this.planStructureContext.planData().courseUnitsById[id];
    }

    getCustomStudyDraft(id: OtmId): CustomStudyDraft {
        return this.planStructureContext.planData().customStudyDraftsById[id];
    }
}
